import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const blockedFlagsMode = {
  block_view_only: 'Visualização',
  block_view_and_consumption: 'Visualização e consumo',
}

export const blockedFlagsModeOptions = strategyToOptions(blockedFlagsMode);
